<template>
  <div id="app" :data-screen="screenLevel" v-on:scroll="screenLevelWatcher">
    <FullScreenLoader :class="{hidden: !isPageLoading || isPostActive || isPolicyPrivacyOpen}" />
    <div class="home" v-if="!isPostActive && !isPolicyPrivacyOpen">
      <GetReport v-if="!isMobile" />
      <ContactBtn v-if="!isMobile" />
      <TheLogo :screen="screenLevel" v-if="!isMobile" />
      <BottomText :isContactPanelActive="isContactPanelActive" v-if="!isMobile" />
      <WelcomePage
        :isMobile="isMobile"
        :activeSection="activeSection"
        :isContactPanelActive="isContactPanelActive"
        :isMobileNavOpen="isMobileNavOpen"
        :isBackgroundPrimary="isBackgroundPrimary"
        :screenLevel="screenLevel"
      />
      <PostsListSection
        :activeSection="activeSection"
        :isContactPanelActive="isContactPanelActive"
        :isMobile="isMobile"
      />
    </div>
    <SinglePost
      v-else-if="isPostActive && !isPolicyPrivacyOpen"
      :postID="activePost"
      :isContactPanelActive="isContactPanelActive"
      :isMobile="isMobile"
    />
    <PolicyPrivacy v-else :isContactPanelActive="isContactPanelActive" />
    <ContactPanel
      :active="isContactPanelActive"
      :isPostActive="isPostActive"
      :isMobile="isMobile"
      :isBackgroundPrimary="isBackgroundPrimary"
      :screenLevel="screenLevel"
      :isPolicyPrivacyOpen="isPolicyPrivacyOpen"
    />
    <CookieBar v-if="isCookieBarActive" />
    <MobileNavBar
      v-if="(isPostActive || isPolicyPrivacyOpen) && isMobile"
      :isBackgroundPrimary="true"
      screenLevel="top"
      :isContactPanelActive="isContactPanelActive"
      :isMobileNavOpen="isMobileNavOpen"
    />
    <MobileNavPanel
      v-if="isMobile"
      :isContactPanelActive="isContactPanelActive"
      :isMobileNavOpen="isMobileNavOpen"
      :isBackgroundPrimary="isBackgroundPrimary"
      :screenLevel="screenLevel"
      :isPolicyPrivacyOpen="isPolicyPrivacyOpen"
      :isPostActive="isPostActive"
    />
  </div>
</template>

<script>
import { bus } from "./main";

import _ from "lodash";

import GetReport from "./components/GetReport.vue";
import TheLogo from "./components/TheLogo.vue";
import BottomText from "./components/BottomText.vue";
import ContactBtn from "./components/ContactBtn.vue";
import ContactPanel from "./components/ContactPanel.vue";
import WelcomePage from "./components/sections/WelcomePage.vue";
import PostsListSection from "./components/sections/PostsListSection.vue";
import SinglePost from "./components/sections/SinglePost.vue";
import CookieBar from "./components/CookieBar";
import PolicyPrivacy from "./components/sections/PolicyPrivacy";
import FullScreenLoader from "./components/sections/FullScreenLoader";

// mobile elements
import MobileNavPanel from "./components/mobile/MobileNavPanel";
import MobileNavBar from "./components/mobile/MobileNavBar";

export default {
  name: "App",
  components: {
    GetReport,
    TheLogo,
    BottomText,
    ContactBtn,
    ContactPanel,
    WelcomePage,
    PostsListSection,
    SinglePost,
    CookieBar,
    PolicyPrivacy,
    FullScreenLoader,

    // mobile
    MobileNavPanel,
    MobileNavBar
  },
  data: function() {
    return {
      // TODO: merge screenLevel and activeSection if possible
      // for Logo changing
      screenLevel: "top",
      // for fullscreen scroller
      inMove: false,
      activeSection: 0,
      offsets: [],
      touchStartY: 0,
      isPageLoading: true,

      // for fullscreen scroller 2
      isWelcomeVisible: true,
      isTopOfPostList: false,

      isPostActive: false,
      activePost: 0,
      isCookieBarActive: true,

      //Contact Panel status
      isContactPanelActive: false,

      // PolicyPrivacy status
      isPolicyPrivacyOpen: false,

      // Mobile
      isMobile: false,
      isMobileNavOpen: false,
      isBackgroundPrimary: true
    };
  },
  methods: {
    incrementActiveSection(activeSection = this.activeSection + 1) {
      this.activeSection = activeSection <= 1 ? activeSection : 1;
    },

    showPost(postID = 0) {
      this.isPostActive = true;
      this.activePost = postID;
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
      });
    },
    hidePost(sectionToShow = "top") {
      this.screenLevel = sectionToShow;
      this.isPostActive = false;
      this.activePost = null;

      // TODO: to nie działa za dobrze \/
      if (sectionToShow === "post-list") {
        this.activeSection = 1;
        window.scrollTo(0, this.offsets[1]);
      } else {
        this.activeSection = 0;
        window.scrollTo(0, 0);
      }
    },

    changeBackground: function() {
      // If window is not at the top dont change background color
      if (this.screenLevel === "top") {
        this.isBackgroundPrimary = !this.isBackgroundPrimary;
      }
    },

    mobileNavHandler(forceHide = false, backToHome = false) {
      if (backToHome) {
        if (this.isPostActive && this.isMobileNavOpen) {
          this.hidePost("post-list");
        }
        if (this.isPolicyPrivacyOpen && this.isMobileNavOpen) {
          this.hidePP();
        }
      }

      if (forceHide) {
        this.isMobileNavOpen = false;
        // this.isPostActive = false;
      } else {
        this.isMobileNavOpen = !this.isMobileNavOpen;
      }
    },

    setCookie: function(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    isPPAgreed: function() {
      if (
        document.cookie
          .split(";")
          .some(item => item.includes("policy-privacy-agreed=true"))
      ) {
        this.isCookieBarActive = false;
      } else {
        this.isCookieBarActive = true;
      }
    },

    contactPanelHandler: function(forceHide = false) {
      if (!forceHide) {
        this.isContactPanelActive = !this.isContactPanelActive;
      } else {
        this.isContactPanelActive = false;
      }
    },

    screenLevelWatcher: function() {
      const offset = 60;
      // switch app data
      if (window.innerHeight <= window.scrollY + offset) {
        this.screenLevel = "bottom";
        this.activeSection = 1;
      } else {
        this.screenLevel = "top";
        this.activeSection = 0;
      }

      // autoscroll to bottom sections
      if (window.innerHeight > window.scrollY && !this.isPostActive) {
        this.isWelcomeVisible = true;
      } else {
        this.isWelcomeVisible = false;
      }

      if (window.innerHeight === window.scrollY) {
        this.isTopOfPostList = true;
      } else {
        this.isTopOfPostList = false;
      }
    },

    showPP() {
      this.isPolicyPrivacyOpen = true;
      this.isWelcomeVisible = false;
    },
    hidePP() {
      this.isPolicyPrivacyOpen = false;
    },

    RWDWatcher() {
      const mobile = 980; // if this changes, dont forget to change this value in _variables.scss
      const windowWidth = window.innerWidth;

      if (windowWidth > mobile) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },

    calculateSectionOffsets: function() {
      const sections = document.querySelectorAll(".section");
      const length = sections.length;

      for (let i = 0; i < length; i++) {
        const sectionOffset = sections[i].offsetTop;
        this.offsets.push(sectionOffset);
      }
    },

    // fullscreenScroll: function() {
    //   // console.log(e.wheelDelta);

    //   if (this.isWelcomeVisible) {
    //     // scroll movement for desktop and swipe on mobile devices
    //     window.addEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
    //     window.addEventListener("mousewheel", this.handleMouseWheel, {
    //       passive: false
    //     }); // Other browsers
    //     window.addEventListener("touchstart", this.touchStart, {
    //       passive: false
    //     }); // mobile devices
    //     window.addEventListener("touchmove", this.touchMove, {
    //       passive: false
    //     }); // mobile devices
    //   } else {
    //     // scroll movement for desktop and swipe on mobile devices
    //     window.removeEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
    //     window.removeEventListener("mousewheel", this.handleMouseWheel, {
    //       passive: false
    //     }); // Other browsers
    //     window.removeEventListener("touchstart", this.touchStart, {
    //       passive: false
    //     }); // mobile devices
    //     window.removeEventListener("touchmove", this.touchMove, {
    //       passive: false
    //     }); // mobile devices
    //   }
    // },

    scrollToSection(id, force = false) {
      const sections = document.querySelectorAll(".section");

      if (this.inMove && !force) return false;

      // this.activeSection = id;

      this.inMove = true;
      sections[id].scrollIntoView({ behavior: "smooth" });

      setTimeout(() => {
        this.inMove = false;
      }, 400);

      // add active class to active section
      sections.forEach(el => el.classList.remove("active"));
      sections[id].classList.add("active");
    },
    changePost(postID) {
      this.activePost = postID;
      window.scrollTo(0, 0);
      return;
    },

    hideLoader() {
      this.isPageLoading = false;
    }

    // handleMouseWheel: function(e) {
    //   if (e.wheelDelta < 30 && !this.inMove) {
    //     this.moveUp();
    //   } else if (e.wheelDelta > 30 && !this.inMove) {
    //     this.moveDown();
    //   }
    //   e.preventDefault();
    //   return false;
    // },

    // moveDown() {
    //   this.inMove = true;
    //   this.activeSection--;
    //   if (this.activeSection < 0) this.activeSection = 0;
    //   // LEGACY BEHAVIOUR
    //   // if (this.activeSection < 0) this.activeSection = this.offsets.length - 1;
    //   this.scrollToSection(this.activeSection, true);
    // },
    // moveUp() {
    //   // disable fullscreen scroll if on second section
    //   this.inMove = true;
    //   this.activeSection++;
    //   if (this.activeSection >= this.offsets.length)
    //     this.activeSection = this.offsets.length - 1;
    //   // LEGACY BEHAVIOUR
    //   // if (this.activeSection > this.offsets.length - 1) this.activeSection = 0;
    //   this.scrollToSection(this.activeSection, true);
    // },

    // touchStart(e) {
    //   // disable fullscreen scroll if on second section

    //   e.preventDefault();
    //   this.touchStartY = e.touches[0].clientY;
    // },
    // touchMove(e) {
    //   // disable fullscreen scroll if on second section

    //   if (this.inMove) return false;
    //   e.preventDefault();
    //   const currentY = e.touches[0].clientY;
    //   if (this.touchStartY < currentY) {
    //     this.moveDown();
    //   } else {
    //     this.moveUp();
    //   }
    //   this.touchStartY = 0;
    //   return false;
    // }
  },
  created() {
    bus.$on("activeSection", this.incrementActiveSection);
    bus.$on("scrollToNextSection", this.scrollToSection);
    bus.$on("showPost", this.showPost);
    bus.$on("hidePost", this.hidePost);
    bus.$on("contactPanelHandler", this.contactPanelHandler);
    bus.$on("hidePP", this.hidePP);
    bus.$on("showPP", this.showPP);
    bus.$on("mobileNavClickHandler", this.mobileNavHandler);
    bus.$on("backgroundHandler", this.changeBackground);
    bus.$on("changePost", this.changePost);
    bus.$on("hideLoader", this.hideLoader);
  },
  mounted() {
    window.addEventListener("scroll", _.throttle(this.screenLevelWatcher, 100));
    // section scroll
    this.calculateSectionOffsets();
    // window.addEventListener("scroll", _.throttle(this.fullscreenScroll, 100));

    // offset properties init
    this.screenLevelWatcher();

    // check privacy policy agreements
    this.isPPAgreed();

    // RWD watcher
    window.addEventListener("resize", _.throttle(this.RWDWatcher, 100));
    // init
    this.RWDWatcher();
  },
  destroyed() {
    window.removeEventListener(
      "scroll",
      _.throttle(this.screenLevelWatcher),
      100
    );
  },
  updated() {
    // check privacy policy agreements
    this.isPPAgreed();
  }
};
</script>

<style lang="scss">
// Fonts
@import "./assets/styles/_fonts.scss";
// Import outer styles
@import "./assets/styles/_reset.scss";
@import "./assets/styles/_global.scss";
@import "./assets/styles/_animations.scss";
@import "./assets/styles/_rwd.scss";
</style>
